import { compact, last } from 'lodash-es'

export const headerHeight = 76
export const knobsPanelHeight = 59
export const feedDescriptionHeight = 72
export const knobsPanelMobileHeight = 105
export const headerMobileHeight = 38
export const mobileBreakpoint = 578

export const colors = {
  goldColor: '#eecf83',
  blueColor: '#5197e9'
}

export const defaultMenuOptions = [
  // { to: '/search', text: 'Custom Feed' }
]

export const getProfileMenuOptions = ({ isInEditPinsMode, profileFeeds, segments, isMyProfile }) => {
  const privateProfileFeeds = !isMyProfile ? profileFeeds.filter(f => f.url !== '/saved') : profileFeeds
  const home = privateProfileFeeds.filter(f => f.get('url') === '/')[0]
  const picks = privateProfileFeeds.filter(f => f.get('url') === '/picks')[0]
  const collections = privateProfileFeeds.filter(f => f.get('url') === '/collections')[0]
  const saved = privateProfileFeeds.filter(f => f.get('url') === '/saved')[0]

  if (home) {
    home.to = `/${segments[0]}`
    home.exact = true
  }
  if (picks) {
    picks.to = `/${segments[0]}/picks`
  }
  if (collections) {
    collections.to = `/${segments[0]}/collections`
  }
  if (saved) {
    saved.to = `/${segments[0]}/saved`
  }
  return compact([
    !isInEditPinsMode && !home && { to: `/${segments[0]}`, text: 'Home', exact: true },
    !picks && { to: `/${segments[0]}/highlights`, text: 'Highlights' },
    !picks && { to: `/${segments[0]}/picks`, text: 'Picks' },
    !collections && { to: `/${segments[0]}/collections`, text: 'Collections' },
    ...(!isInEditPinsMode ? getCustomMenuOptions({ feeds: privateProfileFeeds, segments }) : [])
  ])
}

export const getCustomMenuOptions = ({ feeds, segments }) => {
  return feeds.map(f => {
    if (f && f.get) {
      return {
        to: f.get('to') || {
          pathname: `${segments ? '/' + segments[0] : ''}/${
            f.get('url').includes('collections') && !f.get('url').includes('type=collections')
              ? `collection-feed/${last(f.get('url').split('/')).split('?')[0]}`
              : `custom-feed/${last(f.get('slug').split('/'))}`
          }`,
          search:
            !!f.get('url').includes('collections') && last(f.get('url').split('/')).split('?')[1]
              ? '?' + last(f.get('url').split('/')).split('?')[1]
              : ''
        },
        text: f.get('name'),
        query: f.getIn(['query', 'object']),
        description: f.get('description'),
        user: f.get('user'),
        url: f.get('url') || f.get('to')
      }
    } else {
      return null
    }
  })
}
